import I18N from '@leverege/i18n';
import { GlobalState, UI } from '@leverege/ui-redux';
const {
  t,
  tIcon
} = I18N.ns('molten.mapDataViewer.google.TiltUp');
export default {
  id: 'molten.mapDataViewer.google.TiltUp',
  matches: {
    client: 'GoogleMapsDataViewer',
    use: 'bottomLeftActionBar'
  },
  layout: {
    sort: 'tilt-up'
  },
  handles: context => {
    const {
      streetView,
      renderingType
    } = context;
    const mapEditing = UI.get(GlobalState.get(), 'mapEditing');
    return !mapEditing && !streetView && renderingType === 'VECTOR';
  },
  appearance: ({
    context
  }) => {
    return {
      name: t('name'),
      prefer: 'icon',
      icon: tIcon('icon', 'fa fa-fw fa-arrow-up')
    };
  },
  perform: ({
    context
  }) => {
    const {
      mapViewer
    } = context;
    const {
      map
    } = mapViewer;
    const tilt = map.getTilt();
    map.setTilt(tilt - 20);
  }
};